import {Component, computed, inject, input} from '@angular/core';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {UsageStore} from '../statistics/usage.store';
import {GgTooltipDirective} from '../components/gg-tooltip.directive';
import {IconComponent} from '../components/icon/icon.component';

/**
 * Topbarový blok plánu. Průběžný stav plánu nese kroužek kolem avataru v profilu (sidebar), takže
 * topbar ukáže zbývající limit JEN když dochází (zbývá ≤ 20 % → warning = informace, ne dekorace);
 * FREE plán navíc dostane gradientní CTA „Koupit předplatné".
 *
 * `variant="sidebar"` = totéž CTA celořádkově do patičky menu pro mobil, kde je topbarový blok
 * schovaný (`hidden md:inline-flex`). Stav plánu tam nese profil, stejně jako na desktopu.
 * Za to, aby se obě varianty nezobrazily naráz, odpovídá volající.
 */
@Component({
    selector: 'app-usage-chip',
    imports: [TranslatePipe, GgTooltipDirective, IconComponent],
    template: `
        @if (variant() === 'sidebar') {
            @if (isFree()) {
                <button class="btn btn-sm w-full border-0 bg-gradient-to-r from-primary to-secondary text-primary-content shadow-sm hover:brightness-110"
                        (click)="goToSubscription()">
                    <app-icon icon="ph:rocket" size="sm"/>
                    {{ 'topbar.usage.buy' | translate }}
                </button>
            }
        } @else {
            @if (store.lowRemaining() && store.remainingPercent() !== null) {
                <button class="btn btn-ghost btn-sm gap-2 hidden md:inline-flex"
                        [attr.aria-label]="'topbar.usage.aria' | translate"
                        [appTooltip]="'dashboard.alert.usage.hint' | translate"
                        placement="bottom"
                        (click)="goToSubscription()">
                    <progress class="progress progress-warning w-10" [value]="store.remainingPercent()" max="100"></progress>
                    <span class="text-xs whitespace-nowrap text-warning font-semibold">
                        <app-icon icon="app:warning" size="sm" class="align-text-bottom"/>
                        {{ 'topbar.usage.remaining' | translate: {remaining: store.remainingPercent()} }}
                    </span>
                </button>
            }
            @if (isFree()) {
                <button class="btn btn-sm border-0 bg-gradient-to-r from-primary to-secondary text-primary-content shadow-sm hover:brightness-110 hidden md:inline-flex"
                        (click)="goToSubscription()">
                    <app-icon icon="ph:rocket" size="sm"/>
                    {{ 'topbar.usage.buy' | translate }}
                </button>
            }
        }
    `,
})
export class UsageChipComponent {
    protected readonly store = inject(UsageStore);
    private readonly router = inject(Router);

    /** 'topbar' = kompaktní chip (výchozí), 'sidebar' = celořádková varianta do patičky menu. */
    readonly variant = input<'topbar' | 'sidebar'>('topbar');

    /** Zrcadlí `plan-alert` kind 'free': žádné předplatné po dokončeném načtení. */
    protected readonly isFree = computed(() => !this.store.loading() && !this.store.subscription());

    goToSubscription(): void {
        this.router.navigate(['/page/subscription']);
    }
}
